import { EmailsActionTypes } from './constants';

type EmailsAction = { type: string; payload: {} | string };

// common success
export const emailApiResponseSuccess = (actionType: string, data: any): EmailsAction => ({
    type: EmailsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const emailApiResponseError = (actionType: string, error: string): EmailsAction => ({
    type: EmailsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getEmails = (): EmailsAction => ({
    type: EmailsActionTypes.GET_EMAILS,
    payload: {},
});

export const getEmailById = (id: string): EmailsAction => ({
    type: EmailsActionTypes.GET_EMAIL_BY_ID,
    payload: { id },
});

export const getEmailsByUser = (user: string): EmailsAction => ({
    type: EmailsActionTypes.GET_EMAILS_BY_USER,
    payload: { user },
});

export const getEmailsByTransaction = (transaction: string): EmailsAction => ({
    type: EmailsActionTypes.GET_EMAILS_BY_TRANSACTION,
    payload: { transaction },
});

export const createEmail = (parent: string, id: string, data: object): EmailsAction => ({
    type: EmailsActionTypes.CREATE_EMAIL,
    payload: { parent, id, data },
});

export const updateEmail = (id: string, data: object): EmailsAction => ({
    type: EmailsActionTypes.UPDATE_EMAIL,
    payload: { id, data },
});

export const deleteEmail = (id: string): EmailsAction => ({
    type: EmailsActionTypes.DELETE_EMAIL,
    payload: { id },
});

export const archiveEmail = (id: string): EmailsAction => ({
    type: EmailsActionTypes.ARCHIVE_EMAIL,
    payload: { id },
});

export const createEmailAttachment = (id: string, data: object): EmailsAction => ({
    type: EmailsActionTypes.CREATE_ATTACHMENT,
    payload: { id, data },
});

export const resetEmails = (): EmailsAction => ({
    type: EmailsActionTypes.RESET_EMAILS,
    payload: {},
});
